import React, {Component} from 'react'
import {List, ListItem, Typography, Button} from '@material-ui/core'

/**
 * purchases
 * selected
 * width_auto - фикс размера для диалога
 *   - показывать или нет кнопку завершения
 * 
 * onPurchaseClick(purchase)
 * onPurchaseDoubleClick(purchase)
 * onPurchaseStatusClick(purchase)
 */

class PurchaseList extends Component {

    render() {

        const getButtonTitle = (purchase) => {
            switch(purchase.status) {
                case 0: return "Утвердить"
                case 1: return "Завершить"
                default: return "Завершена"
            }
        }

        let purchases = this.props["purchases"] ? this.props["purchases"] : []

        return <List>
            {purchases.map((purchase, n) => <ListItem 
                style = {{display: "flex", gap: "10px"}}
                key={n}
                button
                selected = {this.props.selected ? this.props.selected["id"] === purchase["id"] : false}
                onClick = {e => {
                    e.stopPropagation()
                    if (typeof this.props.onPurchaseClick === "function") {
                        this.props.onPurchaseClick(purchase)
                    }
                }}
                onDoubleClick={e => {
                    e.stopPropagation()
                    if (typeof this.props.onPurchaseDoubleClick === "function") {
                        this.props.onPurchaseDoubleClick(purchase)
                    }
                }}
            >
                
                <div style={{flex: "1 1 auto"}}>
                    <Typography variant='h5'>{purchase.name}</Typography>
                    <Typography variant='subtitle2'>Создал: {purchase.user.name}</Typography>
                    <Typography variant='subtitle2'>Дата создания: {purchase.create_date}</Typography>
                </div>

                {this.props.hide_complete_buttons ? undefined : <div style={{minWidth: "100px", flex: "0 0 auto", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <Button
                        variant = "contained"
                        disabled = {purchase.status >= 2}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onPurchaseStatusClick === "function" ) {
                                this.props.onPurchaseStatusClick(purchase)
                            }
                        }}
                        onDoubleClick={e => e.stopPropagation()}
                    >
                        {getButtonTitle(purchase)}
                    </Button>
                </div>}                

            </ListItem>)}
        </List>
    }

}

export default PurchaseList